export default __webpack_public_path__ + "static/media/Q18_4_resized.23c0263a.jpg";